export enum DoubleEliminationGroup {
  Upper,
  Lower,
  GrandFinal,
}
